<template>
	<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
		<tr>
			<th>排名</th>
			<th>企业名称</th>
			<th>所属产业</th>
			<th>画像标签</th>
			<th>地区</th>
			<th>企业实力</th>
			<th>编辑</th>
		</tr>
		<tr :key="i" v-for="(list,i) in enterprise_list">
			<td>{{(page-1)*pageSize+i+1}}</td>
			<td class="title" @click="routerlinkid('/enterprises',list.stockCode)">
				{{list.title}}
			</td>
			<td class="conpanytags hastag">
				<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
					@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
			</td>
			<td class="conpanytags notiontags">
				<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
					@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
			</td>
			<td>{{list.area}}</td>
			<td>{{list.zs100000}}</td>
			<td class="collectfont1"><span
					@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
			</td>
		</tr>
	</table>
</template> 
<script>
	export default {
		name: 'domesticTable',
		data() {
			return {
				title:"全部内资企业的表格",
				enterprise_list:[],
				pageSize:20,
				userdata:{},
		}},
		watch:{
			list:{
				handler(newval,oldval){
					this.list=newval;
					this.enterprise_list=this.list;
				}
			}, 
			page:{
				handler(newval,oldval){
					this.page=newval;
					// this.page=newval;
				}
			}, 
		},
		props:{
			list:{type:Array },
			page:{type:Number,default:1}, 
		},
		created() {
			this.enterprise_list=this.list;
			this.userdata=this.getuseriformation();
		}
	}
</script>

<style>
</style>